import { useAtomValue } from "jotai";
import { userAtom } from "../store/atoms";

export const useUser = () => {
  const user = useAtomValue(userAtom);

  return {
    userId: user.id,
    userName: user.name,
    userEmail: user.email,
    user,
  };
};
